import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import LinearProgress from "@material-ui/core/LinearProgress";
import Exitoso from "../Exitoso";
import Error from "../Error";

import { BASE_URL } from "../../../utils/index";
import { postJson } from "../../../utils/postJson";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    "& > * + *": {
      marginTop: theme.spacing(2),
    },
  },
}));

export default function LoadingServicio(props) {
  // console.log(props.values);
  useEffect(() => {
    const requestHandle = async () => {
      //Data
      const {
        tipo,
        turno,
        destino,
        direccionHospital,
        fechaEnviar,
        idPrimerPaciente,
        primerPaciente,
        puebloPrimerPaciente,
        telfPrimerPaciente,
        telfPrimerPaciente2,
        direccionPrimerPaciente,
        NASS1,
        idSegundoPaciente,
        segundoPaciente,
        puebloSegundoPaciente,
        telfSegundoPaciente,
        telfSegundoPaciente2,
        direccionSegundoPaciente,
        NASS2,
        email,
        idCliente,
        idClienteSol,
        perfilLog,
        urgente,
        alta,
        ingres,
      } = props.values;
      //Fetch
      const response2 = await postJson(
        `${BASE_URL}/pedirViaje`,
        {
          email: email,
          fecha: fechaEnviar,
          tipo: tipo,
          idPrimerPaciente: idPrimerPaciente,
          idDireccionPaciente1: props.values.idDireccionPaciente1,
          primerPaciente: primerPaciente,
          puebloPrimerPaciente: puebloPrimerPaciente.title,
          telfPrimerPaciente: telfPrimerPaciente,
          telfPrimerPaciente2:
            telfPrimerPaciente2 != "" ? telfPrimerPaciente2 : "NO",
          direccionPrimerPaciente: direccionPrimerPaciente,
          NASS1: NASS1,
          idSegundoPaciente: idSegundoPaciente,
          idDireccionPaciente2: props.values.idDireccionPaciente2,
          segundoPaciente: segundoPaciente,
          puebloSegundoPaciente: puebloSegundoPaciente.title,
          telfSegundoPaciente: telfSegundoPaciente,
          telfSegundoPaciente2:
            telfSegundoPaciente2 !== "" ? telfSegundoPaciente2 : "NO",
          direccionSegundoPaciente: direccionSegundoPaciente,
          NASS2: NASS2,
          direccionHospital: direccionHospital,
          idCliente: perfilLog == 5 ? idClienteSol.id : idCliente,
          turno: turno,
          destino: destino,
          urgente: urgente,
          alta: alta,
          ingres: ingres,
        }
      );
      if (typeof response2.message !== "string") {
        throw new Error("El servidor no confirmó la solicitud.");
      }
      setStateComponent({
        isLoading: false,
        isSuccess: true,
        isError: false,
        message: response2.message,
      });
    };

    requestHandle().catch((error) => {
      setStateComponent({
        isLoading: false,
        isSuccess: false,
        isError: true,
        message: error.message,
      });
    });
  }, []);

  const classes = useStyles();

  const [stateComponent, setStateComponent] = useState({
    isLoading: true,
    isSuccess: false,
    isError: false,
    message: "",
  });

  if (stateComponent.isLoading)
    return (
      <div className={classes.root}>
        <LinearProgress />
      </div>
    );

  if (stateComponent.isSuccess) {
    return <Exitoso message={stateComponent.message} />;
  }

  if (stateComponent.isError) {
    return <Error message={stateComponent.message} />;
  }
}
